import { globalStyle, style, styleVariants } from "@vanilla-extract/css";

import { text } from "~/styles/type.css";
import { vars } from "~/styles/tokens.css";

// The modal surface, on the native <dialog> element: the browser owns the top
// layer, the backdrop, the focus trap and Escape, so none of that is
// re-implemented here; only the skin is ours.
const surface = style({
  maxHeight: "calc(100vh - 2rem)",
  overflowY: "auto",
  padding: vars.space.lg,
  border: `1px solid ${vars.color.borderSubtle}`,
  borderRadius: vars.radius.xl,
  backgroundColor: vars.color.surface,
  color: vars.color.textDefault,
  boxShadow: vars.shadow.lg,
});

export const dialog = styleVariants({
  sm: [surface, { width: "min(28rem, calc(100vw - 2rem))" }],
  lg: [surface, { width: "min(60rem, calc(100vw - 2rem))" }],
});

globalStyle(`${surface}::backdrop`, {
  backgroundColor: vars.color.overlayScrim,
});

export const body = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.md,
});

export const title = style([
  text.title,
  {
    color: vars.color.textDefault,
  },
]);

/** Secondary copy: the dialog's hint under its title, and any aside a body
 *  carries. */
export const hint = style([
  text.micro,
  {
    color: vars.color.textMuted,
    fontWeight: vars.fontWeight.regular,
  },
]);
